// スムーススクロール
$('a[href^="#"]').click(function() {
  if ($("#js-button-menu").hasClass("open")) {
    navClose();
  }

  var speed = 300;
  var href = $(this).attr("href");
  var target = $(href == "#" || href == "" ? "html" : href);

  var nowScroll = $(window).scrollTop();
  var position = target.offset().top;

  $("html,body").animate({scrollTop: position}, speed, "swing");

  return false;
});

// $('.page-top .nav a').click(function() {
//     $('#js-button-menu').removeClass('open');
//     $('.header').removeClass('open');
//     setTimeout(function(){
//       $('.header').removeClass('show');
//     },600);
// });

// ////////////////////////////////////////////
// // TOP IMAGE
// ////////////////////////////////////////////

// メニュー開閉
$("#js-button-menu").click(function() {
  if (!$("#js-button-menu").hasClass("open")) {
    $("#js-button-menu").addClass("open");
    $(".header").addClass("show");
    $("#js-cover-header").addClass("show");
  } else {
    navClose();
  }
});

$("#js-cover-header,#js-button-menu.open").click(function() {
  navClose();
});

function navClose() {
  $(".header").removeClass("show");
  $("#js-button-menu").removeClass("open");
  $("#js-cover-header").removeClass("show");
}

function toggleFixedNav(_winS, _threshold, _dom, _class) {
  if (_winS > _threshold) {
    if (!$(_dom).hasClass(_class)) {
      $(_dom).addClass(_class);
    }
  } else {
    if ($(_dom).hasClass(_class)) {
      $(_dom).removeClass(_class);
    }
  }
}

// ////////////////////////////////////////////
// // loading
// ////////////////////////////////////////////

function loadingHide() {
  setTimeout(function() {
    $("#loading").addClass("hide");
  }, 500);
  setTimeout(function() {
    $("#loading").hide();
  }, 1300);
}

// ////////////////////////////////////////////
// // modal
// ////////////////////////////////////////////

function showModalMov(_movID) {
  var youtubeID = _movID;
  var sethtml =
    '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' +
    youtubeID +
    '?rel=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>';

  $("#modal-mov").fadeIn(function() {
    // $('.box-modal').addClass('show');
    $("#video").html(sethtml);
  });

  return false;
}

function hideModalMov() {
  $("#modal-mov").fadeOut(function() {
    $("#video").html("");
    // $('.box-modal').removeClass('show');
  });
}

$(".modal-movie").on("click", function() {
  var youtubeID = $(this).data("movie");
  showModalMov(youtubeID);
});

$("#modal-close-mov,.btn-modal-close").on("click", hideModalMov);

$(".tap").on("touchstart touchmove touchend", tapHover);

function tapHover(e) {
  var touch = e.originalEvent.touches[0];
  if (e.type == "touchstart") {
    $(this).addClass("hover");
  } else if (e.type == "touchmove") {
  } else if (e.type == "touchend") {
    $(this).removeClass("hover");
  }
}

// ////////////////////////////////////////////
// // 戻るボタンを押したときの確認
// ////////////////////////////////////////////

$(".js-form-back").on("click", backConfirm);

function backConfirm() {
  if (window.confirm("現在入力している内容は失われますがよろしいですか？")) {
    return true;
  } else {
    return false;
  }
}

// ////////////////////////////////////////////
// // マウスホイールによる値の変更を無効化する例
// ////////////////////////////////////////////

$("form").on("focus", "input[type=number]", function(e) {
  $(this).on("wheel.disableScroll", function(e) {
    e.preventDefault();
  });
});
$("form").on("blur", "input[type=number]", function(e) {
  $(this).off("wheel.disableScroll");
});

$("input,textarea,select").each(function() {
  $(this).attr("tabindex", 1);
});
